import { Dialog, DialogContent, Modal } from '@mui/material';
import { FC } from 'react';

type FullImageModalProps = {
  handleClose: () => void;
  image: string | null;
};

const FullImageModal: FC<FullImageModalProps> = ({ handleClose, image }) => (
  <Dialog open={Boolean(image)} onClose={handleClose} maxWidth="xs">
    <DialogContent sx={{ p: 0 }}>
      <img src={image ?? ''} style={{ width: '100%', display: 'block' }} />
    </DialogContent>
  </Dialog>
);

export default FullImageModal;
